import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import LogoutIcon from '@mui/icons-material/Logout'
import { useAuth } from '../../context/useAuth'
import { useNavigate } from 'react-router-dom'

export default function FixedAppBar() {
	const { logout } = useAuth()
	const navigate = useNavigate()
	return (
		<Box sx={{ flexGrow: 1 }}>
			<AppBar position='fixed' elevation={0}>
				<Toolbar variant='dense'>
					<Typography sx={{ cursor: 'pointer' }} onClick={() => navigate('/')} fontWeight={400} variant='h5'>
						Simulation-tool
					</Typography>
					<Box flexGrow={1} />
					<Button onClick={logout} startIcon={<LogoutIcon />} color='inherit'>
						Logout
					</Button>
				</Toolbar>
			</AppBar>
		</Box>
	)
}
